




































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import _ from "lodash";
import moment from "moment";

import MyForm from "@/mixins/form";

import Rules from "@/components/rules.vue";

import TsConfirm from "./confirm.vue";

@Component({
  components: {
    Rules,
    TsConfirm,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() smsRules!: any[];

  rules: any[] = [];

  mobiles = "";

  rulesstr = "";

  confirmModalVisible = false;

  is_only=false;

  remnant = 0;

  tpls: any[] = [];

  tplContent = "";

  smsPlatformId = 3; // 默认上亿

  // previewcontent: string = "";

  validateContent(rule: any, value: string, callback: any) {
    const form = this.form;
    if (this.remnant > 500) {
      callback("短信字数（包括签名）不能超过500个字");
      return;
    }
    if (!this.is_only && (value.indexOf("【") !== -1 || value.indexOf("】") !== -1)) {
      callback("不能包含符号【或】");
      return;
    }
    callback();
  }

  renderOptionName(id: number) {
    const obj = _.find(
      this.smsPlatformOption,
      (o) => Number(o.id) === Number(id)
    );
    if (obj) {
      return obj.name;
    }
    return "";
  }

  handleSubmit() {
    this.form.validateFields(async (err: any, fieldsValue: any) => {
      if (!err) {
        this.confirmLoading = true;

        const values: any = {};
        for (const key in fieldsValue) {
          if (_.get(fieldsValue, [key])) {
            const fieldValue = _.get(fieldsValue, [key]);

            if (fieldValue) {
              if (key === "rules") {
                _.set(
                  values,
                  [key],
                  JSON.stringify(
                    _.sortBy(fieldValue, (o) => Number(o.rule_sort))
                  )
                );
              } else if (moment.isMoment(fieldValue)) {
                _.set(
                  values,
                  [key],
                  moment(fieldValue).format("YYYY-MM-DD HH:mm:ss")
                );
              } else if (_.isArray(fieldValue)) {
                _.set(values, [key], JSON.stringify(fieldValue));
              } else {
                _.set(values, [key], fieldValue);
              }
            }
          }
        }

        const res = await this.$store.dispatch("sms/getMobiles", {
          ...values,
        });
        if (res && res.Data && res.Data !== "{}") {
          // this.$message.success(res.Data)
          this.mobiles = _.join(res.Data, ",");
          if (this.mobiles === "") {
            this.$message.error("没有符合条件的手机号，请重新选择规则");
          }
          this.rulesstr = _.get(values, ["rules"]);
          this.confirmModalVisible = true;
        } else {
          this.$message.error("没有符合条件的手机号，请重新选择规则");
        }

        this.confirmLoading = false;
      }
    });
  }

  hideConfirmModal() {
    this.confirmModalVisible = false;
  }

  changeContent(e: any) {
    // console.log(e)
    const val = `【${this.form.getFieldValue("sign")}】${e.target.value}`;
    this.remnant = val.length;
  }

  mounted() {
    // console.log(this.smsRules);
    this.rules = this.smsRules;
    this.spinLoading = true;
    this.loadTpls();
    this.spinLoading = false;
  }

  async loadTpls() {
    const res = await this.$store.dispatch("sms/tplselect", {});
    if (res && res.Data && res.Data !== "{}") {
      this.tpls = res.Data;
    }
  }

  handleSelect(val: any) {
    // console.log(val)
    const obj = _.find(this.tpls, (o) => Number(o.id) === Number(val));
    // console.log(obj)
    if (obj) {
      this.tplContent = obj.tpl_content;
      this.smsPlatformId = obj.sms_platform;
      this.is_only = this.smsPlatformId==4;
    } else {
      this.tplContent = "";
    }

    const val1 = `【${this.form.getFieldValue("sign")}】${this.tplContent}`;
    this.remnant = val1.length;

    this.form.setFieldsValue({
      content: this.tplContent
    });
  }
}
